import request from '@/utils/request'
import Vue from 'vue'

//  类型列表
export function getInformationListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/information/getInformationListPage',
        params
    })
}

//  详情
export function getInformationDetails(params) {
  return request({
      method: 'POST',
      url: Vue.prototype.baseURL + '/product/information/getInformationDetails',
      params
  })
}